var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"onscreen"},[_c('div',{staticClass:"onscreen--content"},[_c('h1',[_vm._v("OnScreen")])])])
}]

export { render, staticRenderFns }